module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/case-dairys/case-dairy-menu/case-dairy-menu/case-dairy-menu.component.css
// module id = ./src/app/case-dairys/case-dairy-menu/case-dairy-menu/case-dairy-menu.component.css
// module chunks = main